import React from 'react';  // eslint-disable-line

const Spinner = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23">
            <g fill="none" fillRule="evenodd" transform="translate(-4 -4)">
                <path d="M0 1h31v30H0z" />
                <circle cx="15.5" cy="15.5" r="11" stroke="#FFF" strokeLinecap="square" opacity=".4" transform="rotate(37.607 15.5 15.5)" />
                <path stroke="#FFF" d="M22.213 6.786c4.812 3.707 5.709 10.614 2.001 15.427" />
            </g>
        </svg>
    );
};

export default Spinner;
